module.exports = __webpack_public_path__ + "is.svg?ba30d1eb1308572f96dc27307903152d";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/is.svg
// module id = 1426
// module chunks = 0